import { requestBuilder } from '../../http/RequestBuilder';
import type {
    AdminCashJournalTransferDto,
    CancelCashJournalRequestDto,
    CashJournalActionResponseDto,
    ForceApproveCashJournalRequestDto,
    ForceRejectCashJournalRequestDto,
} from '../types/ImOpsTypes';

/**
 * List all active (non-terminal) cash journals.
 * @example GET /api/admin/cash-journals?mode=active
 */
export const useGetActiveCashJournals = requestBuilder.query<
    AdminCashJournalTransferDto[]
>({
    endpoint: '/api/admin/cash-journals?mode=active',
    queryKey: '/api/admin/cash-journals/active',
});

/**
 * List cash journals created within a date range.
 * @example GET /api/admin/cash-journals?fromDate=2026-01-01&toDate=2026-01-31
 */
export const useGetCashJournalsByDateRange = requestBuilder.query<
    AdminCashJournalTransferDto[],
    { fromDate: string; toDate: string; searchKey: number }
>({
    endpoint: ({ fromDate, toDate }) =>
        `/api/admin/cash-journals?fromDate=${fromDate}&toDate=${toDate}`,
    queryKey: ({ fromDate, toDate, searchKey }) =>
        `/api/admin/cash-journals/range/${fromDate}/${toDate}/${searchKey}`,
});

/**
 * Cancel a cash journal.
 * @example POST /api/admin/cash-journals/cancel
 */
export const useCancelCashJournal = requestBuilder.mutation<
    CashJournalActionResponseDto,
    CancelCashJournalRequestDto
>({
    endpoint: '/api/admin/cash-journals/cancel',
    method: 'POST',
});

/**
 * Force-approve a cash journal (non-prod only).
 * @example POST /api/admin/cash-journals/force-approve
 */
export const useForceApproveCashJournal = requestBuilder.mutation<
    CashJournalActionResponseDto,
    ForceApproveCashJournalRequestDto
>({
    endpoint: '/api/admin/cash-journals/force-approve',
    method: 'POST',
});

/**
 * Force-reject a cash journal (non-prod only).
 * @example POST /api/admin/cash-journals/force-reject
 */
export const useForceRejectCashJournal = requestBuilder.mutation<
    CashJournalActionResponseDto,
    ForceRejectCashJournalRequestDto
>({
    endpoint: '/api/admin/cash-journals/force-reject',
    method: 'POST',
});
